/**
 * HOF element. Returns new optimized element factory for given tag
 * name, optional `baseAttribs` defaults and generics for defining
 * supported attributes and children. See {@link ElementFactory} for
 * supported call formats of the resulting function..
 *
 * @param tag -
 * @param baseAttribs -
 */
export const defElement = (tag, baseAttribs) => (...args) => {
    const $tag = typeof args[0] === "string" ? tag + args.shift() : tag;
    const n = args.length;
    const attribs = n > 0
        ? baseAttribs
            ? { ...baseAttribs, ...args[0] }
            : args[0]
        : baseAttribs || null;
    return n > 1 ? [$tag, attribs, ...args.slice(1)] : [$tag, attribs];
};
/**
 * @internal
 */
export const defElements = (tags) => tags.map((t) => defElement(t));
